import { Button } from 'components/common/button';
import { withDeviceType } from 'components/common/device-type';
import { compose } from 'redux';

const enhance = compose(withDeviceType);
const ButtonContainer = enhance(Button);

export { ButtonContainer };
